"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Checkbox = void 0;
const tslib_1 = require("tslib");
const React = tslib_1.__importStar(require("react"));
const checkbox_1 = tslib_1.__importDefault(require("antd/es/checkbox"));
exports.Checkbox = (_a) => {
    var { className = '' } = _a, props = tslib_1.__rest(_a, ["className"]);
    return React.createElement(checkbox_1.default, Object.assign({ className: `clp-checkbox ${className}` }, props));
};
//# sourceMappingURL=Checkbox.js.map